// src/features/executive/sales/hooks/use-top-procedures.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import SalesApi from 'api/executive/sales.api'
import type {
  GetTopProceduresParams,
  TopProceduresResponse,
  ExecutiveFilterState,
} from 'api/executive/executive.types'

export function useTopProcedures(scopedFilters?: Partial<ExecutiveFilterState>, limit = 10) {
  return useExecutiveQuery<GetTopProceduresParams, TopProceduresResponse>(
    'sales.top-procedures',
    SalesApi.getTopProcedures,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
        txCategoryId: f.txCategoryId ?? undefined,
        patientType: f.patientType ?? undefined,
        appointmentStatus: f.appointmentStatus ?? undefined,
        limit,
      }
    },
    { scopedFilters }
  )
}
